import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/dashboards/services/data.service';
import { CandidateStore } from 'src/app/dashboards/store/candidate-store';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { environment } from 'src/environments/environment';
import { AccountTypes } from '../../../../shared/models/AccountTypes';
import { AuthenticationResult } from '../../../../shared/models/authentication-result';
import { Navigation } from '../../../../shared/models/navigation';

@Component({
  selector: 'app-dashboard-candidate-main',
  templateUrl: './dashboard-main.component.html',
  styleUrls: ['./dashboard-main.component.scss']
})
export class DashboardCandidateMainComponent implements OnInit {

  private defaultPhotoPath: string = "assets/images/avatar/04.jpg";
  fullName: string = "";
  accountId: string;
  photoPath: string = "";
  user: AuthenticationResult = null;
  navigations: Navigation[] = [];

  constructor(private dashboardState: CandidateStore, private uiState: UiStateStore, private dataService: DataService) {
    this.photoPath = this.defaultPhotoPath;
  }

  ngOnInit() {
    this.uiState.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }

      this.user = user;
      this.navigations = this.user.accountType == AccountTypes.Candidate ? Navigation.getCandidateNavigations() : Navigation.getEmployerNavigations();
      this.accountId = user.accountId;
      this.dataService.getProfile(this.accountId).subscribe(res => { }, err => { });
    });

    this.dashboardState.userProfile.subscribe(up => {
      if (!up) {
        this.fullName = "";
        return;
      }

      if(!up.firstName) {
        return;
      }

      this.fullName = `${up.firstName} ${up.lastName}`;
    });

    this.dashboardState.profilePhoto.subscribe(p => {
      if(!p) {
        this.photoPath = this.defaultPhotoPath;
        return;
      }

      this.photoPath = `${environment.baseUrl}/${p}`;
    });

  }

}
